export default "__VITE_ASSET__BrP45xsJ__"